import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";
import download from "../../asset/images/partner-download.svg";
import { toast } from "react-toastify";
import { Frenchisee } from "../../Configuration/Frenchisee_URL";
import UploadIcon from "../../asset/images/uploadImg-white.svg";
import infoIcon from "../../asset/images/information-circle.svg";
import iconError from "../../asset/images/alert-02.svg";
import { decryptData, encryptData, handleDownloadDocument, handleDownloadDocumentFrench, onlyNumber } from "../../CommonMethhods/CommonMethods";
import checkImge from "../../asset/images/check_circle_green.svg";
import SmallLoader from "../../Components/Common/smallLoader";
import docImage from "../../asset/images/photo-img.svg";
import deleteImg from "../../asset/images/delete-red.svg";
import eyeIcon from "../../asset/images/eyeIcon.svg";
import downloadbrokrage from '../../asset/images/download-brokrage.svg';

function FrenchiseeDocumentDetailsPreview(props) {
    const storeToken = localStorage.getItem("ssoToken");
    let FrenchiseeId = localStorage.getItem("frenchiseeId");
    let navigate = useNavigate();
    let frenchiseeDatails = props.frenchiseeDatails;
    const [showModal, setShowModal] = useState(false);
    const [approveModal, setApproveModal] = useState(false);
    const [rejectionData, setRejectionData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");
    const [mtfBase, setMtfBase] = useState("");
    const [bfslSharing, setBfslSharing] = useState("");
    const [apSharingErr, setApSharingErr] = useState("")
    const [mtfErr, setMtfErr] = useState("");
    const [disposition, setDisposition] = useState("");
    const [cashValue, setCashValue] = useState("");
    const [stockValue, setStockValue] = useState("");
    const [remark, setRemark] = useState("");
    const [apShareErr, setApShareErr] = useState("");
    const [bfslShareErr, setBfslShareErr] = useState("");
    const [dispoErr, setDispoErr] = useState("");
    const [docErr, setDocErr] = useState("");
    const [remarkErr, setRemarkErr] = useState("");
    const [approvalDoc, setApprovalDoc] = useState("");
    const [stockErr, setStockErr] = useState("");
    const [cashErr, setCashErr] = useState("");
    const [reasonValid, setReasonValid] = useState(true);
    const [imageModal, setImageModal] = useState(false);
    // const [docError, setDocError] = useState("");
    const [image, setImage] = useState(null);
    const [fileType, setFileType] = useState("");
    const [docLoader, setDocLoader] = useState(false);
    const [allUrl, setAllUrl] = useState([])


    const [documentData, setDocumentData] = useState({
        56: { name: "", isAvailable: false, url: "", type: "" },
    });

    useEffect(() => {
        const doc56 = frenchiseeDatails?.file?.find(
            (item) => item?.type == "56"
        );

        if (doc56) {
            setDocumentData({
                "56": {
                    name: doc56?.dfname || "",
                    isAvailable: true,
                    type: doc56?.type,
                    url: doc56?.url,
                },
            });
        } else {
            setDocumentData({});
        }
    }, [frenchiseeDatails]);

    console.log(frenchiseeDatails, "frenchiseeDatails");
    

    const isUploaded =
        documentData["56"]?.isAvailable;
    // frenchiseeDatails?.file?.some((item) => item?.type === "56");


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const onHide = () => {
        setShowModal(false);
        setSelectedFiles([])
    };
    const getRejectionReason = async () => {
        try {
            const getRejection = await axios.get(
                Frenchisee.REJECT_REASONS,

                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getRejection?.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                setRejectionData(dataResp?.data?.rejectReasons);
            } else {
                toast.error(dataResp?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    const rejectedUpdated = async () => {
        let rejPayload = {
            id: parseInt(FrenchiseeId),
            status: -2,
            reason: selectedFiles,
        }
        let encyData = encryptData(JSON.stringify(rejPayload))

        try {
            const getStatus = await axios.put(
                Frenchisee.REJECTION_UPDATED,
                `${encyData}`,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getStatus.data);

            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                toast.success(dataResp?.data?.message);
                setShowModal(false);
                navigate("/franchisee-onboarding");
            } else {
                setReasonValid(false);
                toast.error(dataResp?.message)
                setShowModal(true);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    useEffect(() => {
        if (!reasonValid) {
            const checkboxes = document.querySelectorAll(".downloadSelect");
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
            setSelectedFiles([]); // Also clear selectedFiles from state
        }
    }, [reasonValid]);

    const getValue = (e, type) => {
         let val = e.target.value.replace(/\D/g, "");
       val = val.slice(0, 3);

        if (type === "ap") {
            if (Number(val) > 100) return;
            // if (val > 100) {
            //     return;
            // }

            setSelectedValue(val);
            if (val === "") {
                setBfslSharing("");
                setApSharingErr("");
                return;
            }
            const numVal = Number(val);
            if (numVal < 10) {
                setApSharingErr("Please enter number between 10 and 100");
                setBfslSharing("");
            } else {
                setApSharingErr("");
                setBfslSharing(100 - numVal);
            }
        }
        else {
            if (val > 50) return;
            setMtfBase(val);
            if (val === "") {
                setMtfErr("");
                return;
            }
            const numVal = Number(val);

            if (numVal < 9) {
                setMtfErr("Please enter number between 9 and 50");
            } else {
                setMtfErr("");
                setApShareErr("");
                setBfslShareErr("");
            }

        }
    };

    const handleDisposition = (e) => {
        const value = e?.target?.value;
        if (value) {
            setDisposition(value);
            setDispoErr("");
            setStockErr("");
            setCashErr("");
        }

        setCashValue("");
        setStockValue("");

    }

    const handleCashChange = (e) => {
        let val = e.target.value;

        if (val === "") {
            setCashValue("");
            setCashErr("");
            return;
        }

        val = Number(val);

        if (val > 200000) return;

        setCashValue(val);

        if (val < 10000) {
            setCashErr("Cash amount must be between 10000 and 200000");
        } else {
            setCashErr("");
        }
    };

    const handleStockChange = (e) => {
        let val = e.target.value;
        if (val === "") {
            setStockValue("");
            setStockErr("");
            return;
        }

        val = Number(val);
        if (val > 200000) return;
        setStockValue(val);
        if (val < 50000) {
            setStockErr("Stock amount must be between 50000 and 200000");
        } else {
            setStockErr("");
        }
    };

    const increaseValue = () => {
        let current = Number(selectedValue || 10);

        if (current < 100) {
            const newVal = current + 1;
            setSelectedValue(newVal);
            setBfslSharing(100 - newVal);
            setApSharingErr("");
        }
    };

    const decreaseValue = () => {
        let current = Number(selectedValue || 10);

        if (current > 10) {
            const newVal = current - 1;
            setSelectedValue(newVal);
            setBfslSharing(100 - newVal);
            setApSharingErr("");
        }
    };

    const approvedStatus = async () => {
        let approvePayload = {
            id: parseInt(FrenchiseeId),
            status: 2,
        }
        let payload = encryptData(JSON.stringify(approvePayload))
        try {
            const getStatus = await axios.put(
                Frenchisee.REJECTION_UPDATED,
                `${payload}`,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getStatus.data);
            let approveRes = JSON.parse(data)
            if (approveRes?.status === 0) {
                toast.success(approveRes?.data?.message);
                // setApproveModal(false)
                navigate("/franchisee-onboarding");
            } else {
                // setApproveModal(true);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const downloadMultiple = (checked = true) => {
        const selectDownload = document.querySelectorAll(".downloadSelect");
        let selectArray = [];
        for (let item of selectDownload) {

            console.log(checked, "checked");
            if (checked) {
                if (item.checked === true) {
                    selectArray.push(parseInt(item.value));
                }
            } else {
                selectArray.push(item.value);
            }
        }
        setSelectedFiles(selectArray);
    };

    const getReason = () => {
        downloadMultiple();
        setReasonValid(true);
    };

    useEffect(() => {
        getRejectionReason();
        setSelectedFiles([]);
    }, []);

    const getApprovalData = async () => {
        let approvePayload = {
            id: parseInt(FrenchiseeId),
            apSharingCommBroking: parseInt(selectedValue),
            bfslSharingCommBroking: bfslSharing !== "" && bfslSharing !== null ? Number(bfslSharing) : 0,
            mtfBaseRateCommMTF: parseFloat(mtfBase),
            bfslSharingCommMTF: 50,
            apSharingCommMTF: 50,
            deposit: disposition,
            cash: cashValue,
            stock: disposition === "cash" ? 0 : stockValue,
            remarks: remark
        }

        console.log(approvePayload, "approvePayload");

        let payload = encryptData(JSON.stringify(approvePayload))

        try {
            const getApproval = await axios.put(
                Frenchisee.UPDATE_APPROVAL,
                payload,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getApproval?.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                approvedStatus();
                // setRejectionData(dataResp?.data?.rejectReasons);
            } else {
                toast.error(dataResp?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };
    const isFormValid =
            selectedValue &&
            Number(selectedValue) >= 10 &&
            Number(selectedValue) <= 100 &&

            mtfBase &&
            Number(mtfBase) >= 9 &&
            Number(mtfBase) <= 50 &&

            disposition &&

            (disposition === "cash" || stockValue) &&

            cashValue &&

            documentData["56"]?.isAvailable &&

            remark &&

            // no errors
            !apSharingErr &&
            !mtfErr &&
            !dispoErr &&
            !stockErr &&
            !cashErr &&
            !docErr &&
            !remarkErr;

    const handleApprovalBtn = () => {

        let isValid = true;

        if (!selectedValue) {
            setApSharingErr("This field cannot be empty");
            isValid = false;
        }
        else if (selectedValue < 10 || selectedValue > 100) {
            setApSharingErr("Please enter number between 10 and 100");
            isValid = false;
        }
        else {
            setApSharingErr("");
        }

        if (!mtfBase) {
            setMtfErr("This field cannot be empty");
            setApShareErr("This field cannot be empty");
            setBfslShareErr("This field cannot be empty");
            isValid = false;
        }
        else if (mtfBase < 9 || mtfBase > 50) {
            setMtfErr("Please enter number between 9 and 50");
            isValid = false;
        }
        else {
            setMtfErr("");
            setApShareErr("");
            setBfslShareErr("");
        }

        if (!disposition) {
            setDispoErr("This field cannot be empty");
            isValid = false;
        } else {
            setDispoErr("");
        }

        if (disposition !== "cash" && !stockValue) {
            setStockErr("This field cannot be empty");
            isValid = false
        } else {
            setStockErr("");
        }

        if (!cashValue) {
            setCashErr("This field cannot be empty");
            isValid = false
        } else {
            setCashErr("");
        }

        if (!documentData["56"]?.isAvailable) {
            setDocErr("Please upload document");
            isValid = false;
        } else {
            setDocErr("");
        }

        if (!remark) {
            setRemarkErr("This field cannot be empty");
            isValid = false;
        } else {
            setRemarkErr("");
        }

        if (isValid) {
            getApprovalData();
        }
    };

    const uploadeDocuments = async (e, type) => {
        setDocLoader(true);
        try {
            const formData = new FormData();

            formData.append("file", e?.target?.files[0]);
            formData.append("type", type);
            formData.append("fid", parseInt(FrenchiseeId));

            const getValue = await axios.post(
                Frenchisee.GetDocumentsList_Url,
                formData,
                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const response = decryptData(getValue?.data);
            let data = JSON.parse(response)

            if (data?.status === 0) {

                let object = {
                    name: e?.target?.files[0]?.name,
                    isAvailable: true,
                    type: type,
                    url: data?.data?.info?.url,
                };
                setDocumentData({ ...documentData, [type]: object });
                setApprovalDoc(e?.target?.files[0]);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        } finally {
            setDocLoader(false);
        }
    };

    const handleImageUpload = (e, type1) => {
        if (e?.target?.files && e?.target?.files?.length > 0) {
            const file = e?.target?.files[0];

            const allowedExtensions = [
                "eml",
                "mbox",
                "vcf",
                "csv",
                "ics",
                "msg",
                "oft",
                "mht",
                "txt"
            ];

            if (file) {
                let size = Math.round(file.size / 1024);
                const fileExtension = file?.name.split(".").pop().toLowerCase();
                setFileType(fileExtension);
                // let fileExtension = file.name.split(".");
                const fileName = file?.name;

                if (size > 2048) {
                    setDocErr("File size should be 2MB or less than that.");
                    return;
                }

                // if (!["png", "jpeg", "jpg", "pdf"].includes(fileExtension)) {
                //     setDocErr("This file format is not supported.");
                //     return;
                // }

                if (!allowedExtensions.includes(fileExtension)) {
                    setDocErr("Only email-related file formats are allowed.");
                    return;
                }

                const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;
                if (specialCharRegex.test(fileName)) {
                    setDocErr("Invalid file name.");
                    return;
                }

                setDocErr("");
                setImage(file);
                uploadeDocuments(e, type1);
            }
        }
    };

    const handleCloseModal = () => {
        setApSharingErr("");
        setMtfErr("")
        setApShareErr("");
        setBfslShareErr("");
        setDispoErr("");
        setDocErr("");
        setRemarkErr("");
        setStockErr("");
        setCashErr("");

        setMtfBase("");
        setSelectedValue("");
        setBfslSharing("");
        setDisposition("");
        setRemark("");
        setStockValue("");
        setCashValue("");
        setApproveModal(false);
    }

    const deleteDocuments = async (data) => {
        try {
            const getDeleteData = await axios.delete(
                `${Frenchisee.GetDocumentsList_Url}?fid=${FrenchiseeId}&fileType=${data}`,

                {
                    // data: encryptedPayload,
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );

            const deletedData = decryptData(getDeleteData?.data);
                let deletedResp = JSON.parse(deletedData)

            if (deletedResp?.status === 0) {
                toast.success(deletedResp?.data?.message);

                let object = { [data]: { name: "", isAvailable: false, type: data, url: "" } };
                setDocumentData({ ...documentData, ...object });
                
                setApprovalDoc(null);

                const fileInput = document.getElementById("approvalFile");
                if (fileInput) fileInput.value = "";
            } else {
                toast.error(deletedResp?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const deleteDoc = (data) => {
        deleteDocuments(data);
    };

    // const handleFileChange = (e) => {
    //     const type = 56;
    //     handleImageUpload(e, type);
    // };

    const handleRemark = (e) => {
        const value = e?.target?.value;
        if (value === "") {
            setRemark("");
            setRemarkErr("");
            return;
        }

        setRemark(value);
        setRemarkErr("");
    }

    const handleNumberPaste = (e, maxLength, setter) => {
        e.preventDefault();

        const pasteData = e.clipboardData.getData("text");
        let numbersOnly = pasteData.replace(/\D/g, "");
        if (!numbersOnly) return;
        numbersOnly = numbersOnly.slice(0, maxLength);
        if (setter === setMtfBase && Number(numbersOnly) > 50) return;
        if (setter === setSelectedValue && Number(numbersOnly) > 100) return;
        setter(numbersOnly);
    };

    const downloadAllDoc = async (data) => {

        try {
            const getAllData = await axios.get(
                `${Frenchisee.Download_AllDoc}?fid=${FrenchiseeId}`,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );

            const getData = decryptData(getAllData?.data);
            let response = JSON.parse(getData)

            console.log(response?.data, "response98766");
            if (response?.status === 0) {
                let files = response?.data;
                window.open(files, "_self", "noopener,noreferrer");
            }
            else {
                toast?.error(response?.message)
            }

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const handleDownloadBtn = () => {
        downloadAllDoc()
    }

    const moveCursorToNumberEnd = (e) => {
        const val = e.target.value;

        if (!val) return;

        const position = val.includes("%") ? val.length - 1 : val.length;

        setTimeout(() => {
            e.target.setSelectionRange(position, position);
        }, 0);
        };


    return (
        <>
            <div className="card-box">
                <div className="card-title">
                    <h2 className="">Document</h2>
                    <span className="download-btn-franch" onClick={() => handleDownloadBtn()}>
                        <img src={download} alt="" className="download-img partner-down" />
                        Download All
                    </span>
                </div>

                <div className="">
                    <div className="">
                        <div className="row imgWrapper">
                            {frenchiseeDatails &&
                                frenchiseeDatails.file?.map((item) => {
                                    {console.log(item, "item8788");
                                    }
                                    return (
                                        <>
                                            <div key={item.id} className='col-md-6 bottom-25'>
                                                <p className='pdf-label'>
                                                    {item?.type === "1" ? "GST DOCUMENT" :
                                                        item?.type === "2" ? "PAN CARD" :
                                                            item?.type === "3" ? "EDUCATION CERTIFICATE" :
                                                                item?.type === "4" ? "AADHAR FRONT OFFICIAL" :
                                                                    item?.type === "5" ? "AADHAR BACK OFFICIAL" :
                                                                        item?.type === "6" ? "MARRIAGE CERTIFICATE" :
                                                                            item?.type === "7" ? "NAME CHANGE DOCUMENT" :
                                                                                item?.type === "8" ? "FIRST WITNESS SIGNATURE" :
                                                                                    item?.type === "9" ? "SECOND WITNESS SIGNATURE" :
                                                                                        item?.type === "10" ? "SELFIE UPLOAD" :
                                                                                            item?.type === "11" ? "CANCELLED CHEQUE" :

                                                                                                item?.type === "12" ? "RESIDENTIAL PASSPORT" :
                                                                                                    item?.type === "13" ? "OFFICIAL PASSPORT" :
                                                                                                        item?.type === "14" ? "RESIDENTIAL DRIVING LICENSE" :
                                                                                                            item?.type === "15" ? "OFFICIAL DRIVING LICENSE" :
                                                                                                                item?.type === "16" ? "RESIDENTIAL VOTERID FRONT SIDE" :
                                                                                                                    item?.type === "17" ? "RESIDENTIAL VOTERID BACK SIDE" :
                                                                                                                        item?.type === "18" ? "OFFICIAL VOTERID FRONT SIDE" :
                                                                                                                            item?.type === "19" ? "OFFICIAL VOTERID BACK SIDE" :
                                                                                                                                item?.type === "20" ? "RESIDENTIAL PASSBOOK" :
                                                                                                                                    item?.type === "21" ? "OFFICIAL PASSBOOK" :
                                                                                                                                        item?.type === "22" ? "RESIDENTIAL ELECTRICITY BILL" :
                                                                                                                                            item?.type === "23" ? "OFFICIAL ELECTRICITY BILL" :
                                                                                                                                                item?.type === "24" ? "RESIDENTIAL TELEPHONE BILL" :
                                                                                                                                                    item?.type === "25" ? "OFFICIAL TELEPHONE BILL" :
                                                                                                                                                        item?.type === "26" ? "RESIDENTIAL RATION CARD" :
                                                                                                                                                            item?.type === "27" ? "OFFICIAL RATION CARD" :

                                                                                                                                                                item?.type === "28" ? "RESIDENTIAL ESTABLISHMENT CERTIFICATE" :
                                                                                                                                                                    item?.type === "29" ? "OFFICIAL ESTABLISHMENT CERTIFICATE" :
                                                                                                                                                                        item?.type === "30" ? "RESIDENTIAL OWNERSHIP AGREEMENT" :
                                                                                                                                                                            item?.type === "31" ? "OFFICIAL OWNERSHIP AGREEMENT" :
                                                                                                                                                                                item?.type === "32" ? "RESIDENTIAL LEAVE AND LICENSE AGREEMENT" :
                                                                                                                                                                                    item?.type === "33" ? "OFFICIAL LEAVE AND LICENSE AGREEMENT" :

                                                                                                                                                                                        item?.type === "34" ? "APPROVAL EMAIL DOCUMENT" :

                                                                                                                                                                                            item?.type === "35" ? "NSE CERTIFICATE" :
                                                                                                                                                                                                item?.type === "36" ? "BSE CERTIFICATE" :
                                                                                                                                                                                                    item?.type === "37" ? "DOs & DONTs CERTIFICATE" :
                                                                                                                                                                                                        item?.type === "46" ? "ESIGN BSE AGREEMENT" :
                                                                                                                                                                                                            item?.type === "47" ? "ESIGN BSE ANNEXURE" :
                                                                                                                                                                                                                item?.type === "48" ? "ESIGN BSE UNDERTAKING" :
                                                                                                                                                                                                                    item?.type === "49" ? "ESIGN NSE AGREEMENT" :
                                                                                                                                                                                                                        item?.type === "50" ? "ESIGN NSE ANNEXURE" :
                                                                                                                                                                                                                            item?.type === "51" ? "ESIGN TERM SHEET" :
                                                                                                                                                                                                                                item?.type === "52" ? "ESIGN INTERNAL AGREEMENT" :
                                                                                                                                                                                                                                    item?.type === "53" ? "WELCOME LETTER" :

                                                                                                                                                                                                                                        item?.type === "54" ? "AADHAR FRONT RESIDENTIAL" :
                                                                                                                                                                                                                                            item?.type === "55" ? "AADHAR BACK RESIDENTIAL" :
                                                                                                                                                                                                                                                item?.type === "56" ? "BACKOFFICE APPROVAL LETTER" :
                                                                                                                                                                                                                                                    item?.type === "57" ? "BANK AND DP DECLARATION" :
                                                                                                                                                                                                                                                        item?.type === "58" ? "OTHER DOCUMENT" :
                                                                                                                                                                                                                                                        item?.type === "59" ? "AP QUESTIONNARIE" :
                                                                                                                                                                                                                                                            null}</p>

                                                <div className='document-wrapper'>

                                                    {item.dfname?.split(".")[1] === 'pdf' ? (
                                                        < iframe src={item.url}
                                                            className="document-pdf partner-down"
                                                            title="frame" />
                                                    )
                                                        :
                                                        (
                                                            <img src={item?.url} className='document-img'
                                                                alt='document-img' />
                                                        )
                                                    }
                                                    <img src={download} alt="" className="download-img partner-down"
                                                        onClick={() => {
                                                            handleDownloadDocumentFrench(item?.url, item?.dfname, item?.type)
                                                        }} />
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                {frenchiseeDatails?.statusId === 1 ? (
                    <div className="partner-btn">
                        <div>
                            <button
                                className="appro-btn"
                                type="submit"
                                onClick={() => setApproveModal(true)}
                            >
                                Upload
                                <img
                                    src={UploadIcon}
                                    alt="upload"
                                    className="down-icon cursor-pointer upload-btns"
                                />
                            </button>
                        </div>
                        <div>
                            <button
                                className="rej-btn"
                                type="submit"
                                onClick={() => setShowModal(true)}
                            >
                                Reject
                            </button>
                        </div>
                        <div>
                            <button
                                className="back-btn"
                                type="submit"
                                onClick={() => {
                                    navigate("/franchisee-onboarding");
                                }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <button
                            className="back-btn"
                            type="submit"
                            onClick={() => {
                                navigate("/franchisee-onboarding");
                            }}
                        >
                            Back
                        </button>
                    </div>
                )}
            </div>

            <Modal
                show={approveModal}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model partner-modal-rejection fran-aprove"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">AP Commercials Brokings</h2>
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={handleCloseModal}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="client-info-status ap-commercial-modal">
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial">
                            <li className="disposition-select-back">
                                <div>
                                    <label htmlFor="" className="form-text">AP Sharing
                                        <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <div className="input-arrow-wrapper">
                                        <input
                                            className="ap-sharing-input"
                                            type="text"
                                            placeholder="Enter Percentage"
                                            min="10"
                                            max="100"
                                            onInput={onlyNumber}
                                            // maxLength={5}
                                            value={
                                            selectedValue !== ""
                                                ? Number(selectedValue) >= 10
                                                ? `${selectedValue}%`
                                                : selectedValue
                                                : ""
                                            }
                                            // value={selectedValue || ""}
                                            onChange={(e) => getValue(e, "ap")}
                                            onPaste={(e) => handleNumberPaste(e, 5, setSelectedValue)}
                                        onFocus={(e) => moveCursorToNumberEnd(e)}
                                            onClick={(e) => moveCursorToNumberEnd(e)}
                                            onKeyUp={(e) => moveCursorToNumberEnd(e)}
                                        />

                                        <div className="arrow-buttons">
                                            <span onClick={increaseValue}>▲</span>
                                            <span onClick={decreaseValue}>▼</span>
                                        </div>
                                    </div>
                                    {apSharingErr &&
                                        <div className="err-wrap-franch">
                                            <img src={iconError} alt="err-icon" />
                                            <span className="common-err franchisee-err">{apSharingErr}</span>
                                        </div>
                                    }

                                </div>
                            </li>
                            <li className="disposition-select-back">
                                <div>
                                    <label htmlFor="" className="form-text">BFSL Sharing</label>

                                    <input
                                        name="partner-source"
                                        disabled
                                        placeholder="Enter Percentage"
                                        id="calculate-val"
                                        // value={bfslSharing ? `${bfslSharing}%` : ""}
                                        value={bfslSharing !== "" && bfslSharing !== null && bfslSharing !== undefined
                                            ? `${bfslSharing}%`
                                            : ""}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="client-info-status ap-commercial-modal franch-approval">
                        <h6 className="commercial-head">AP Commercials MTF</h6>
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                            <li className="disposition-select-back mtf-rate">
                                <div>
                                    <label htmlFor="" className="form-text">MTF Base Rate
                                        <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <div className="input-arrow-wrapper">
                                        <input
                                            className="ap-sharing-input"
                                            type="text"
                                            min="9"
                                            max="50"
                                            onInput={onlyNumber}
                                            maxLength={2}
                                            placeholder="Enter Percentage"
                                            value={mtfBase !== ""
                                                ? Number(mtfBase) >= 9
                                                ? `${mtfBase}%`
                                                : mtfBase
                                                : ""}
                                            
                                            onChange={(e) => getValue(e, "mtf")}
                                            onPaste={(e) => handleNumberPaste(e, 2, setMtfBase)}
                                            onFocus={(e) => moveCursorToNumberEnd(e)}
                                            onClick={(e) => moveCursorToNumberEnd(e)}
                                            onKeyUp={(e) => moveCursorToNumberEnd(e)}
                                        />

                                        {/* <div className="arrow-buttons">
                                        <span onClick={increaseValue}>▲</span>
                                        <span onClick={decreaseValue}>▼</span>
                                    </div> */}
                                    </div>
                                    {!mtfErr &&
                                        <span className="wrap-info">
                                            <img src={infoIcon} alt="info-icons" />
                                            MTF Sharing above base rate is 50%
                                        </span>
                                    }
                                    {mtfErr &&
                                        <div className="err-wrap-franch">
                                            <img src={iconError} alt="err-icon" />
                                            <span className="common-err franchisee-err">{mtfErr}</span>
                                        </div>
                                    }

                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="client-info-status ap-commercial-modal">
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                            <li className="disposition-select-back">
                                <div>
                                    <label htmlFor="" className="form-text">AP Sharing
                                        <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <input
                                        type="text"
                                        disabled
                                        placeholder="Enter Percentage"
                                        value={mtfBase?.length > 0 ? "50%" : ""}
                                    />

                                </div>
                                {apShareErr &&
                                    <div className="err-wrap-franch">
                                        <img src={iconError} alt="err-icon" />
                                        <span className="common-err franchisee-err">{apShareErr}</span>
                                    </div>
                                }
                            </li>

                            <li className="disposition-select-back">
                                <div>
                                    <label htmlFor="" className="form-text">BFSL Sharing
                                        <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter Percentage"
                                        disabled
                                        value={mtfBase?.length > 0 ? "50%" : ""}
                                    />
                                </div>
                                {bfslShareErr &&
                                    <div className="err-wrap-franch">
                                        <img src={iconError} alt="err-icon" />
                                        <span className="common-err franchisee-err">{bfslShareErr}</span>
                                    </div>
                                }
                            </li>

                        </ul>
                        {/* <div className="err-handle">
                        <span className="mtf-info">
                        <span className="icon-info-icon info"></span>
                            MTF sharing to be done over and above base rate
                        </span>
                    </div> */}
                    </div>

                    <div className="client-info-status ap-commercial-modal">
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                            <li className="disposition-select-back mtf-rate">
                                <div>
                                    <label htmlFor="" className="form-text">Deposit
                                        <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                        id="mtf-data"
                                        value={disposition}
                                        onChange={handleDisposition}>
                                        <option value="">Select Deposit</option>
                                        <option value="stock-cash">Stock & Cash</option>
                                        <option value="cash">Cash</option>
                                    </select>
                                    {dispoErr &&
                                        <div className="err-wrap-franch">
                                            <img src={iconError} alt="err-icon" />
                                            <span className="common-err franchisee-err">{dispoErr}</span>
                                        </div>
                                    }

                                </div>
                            </li>
                        </ul>
                    </div>

                    {disposition &&
                        <div className="client-info-status ap-commercial-modal">
                            <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                                <li className="disposition-select-back">
                                    <div className="stock-text-wrapper">
                                        <label htmlFor="" className="form-text">Stock
                                            <span style={{ color: "red" }}>*</span>
                                        </label>
                                        {disposition !== "cash" &&
                                            <span className="gray-text-val">Min 50000 - Max 200000</span>
                                        }
                                    </div>
                                    <input
                                        type="text"
                                        value={disposition === "cash" ? "0" : stockValue}
                                        onChange={handleStockChange}
                                        disabled={disposition === "cash"}
                                        min="50000"
                                        max="200000"
                                        maxLength={6}
                                        onInput={onlyNumber}
                                        placeholder="Enter Stock Amount"
                                        onPaste={(e) => handleNumberPaste(e, 6, setStockValue)}
                                    />
                                    {stockErr &&
                                        <div className="err-wrap-franch">
                                            <img src={iconError} alt="err-icon" />
                                            <span className="common-err franchisee-err">{stockErr}</span>
                                        </div>
                                    }
                                </li>

                                <li className="disposition-select-back">
                                    <div className="stock-text-wrapper">
                                        <label htmlFor="" className="form-text">Cash
                                            <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <span className="gray-text-val">Min 10000 - Max 200000</span>
                                    </div>

                                    <input
                                        type="text"
                                        value={cashValue}
                                        onChange={handleCashChange}
                                        min="10000"
                                        max="200000"
                                        maxLength={6}
                                        onInput={onlyNumber}
                                        placeholder="Enter Cash Amount"
                                        onPaste={(e) => handleNumberPaste(e, 6, setCashValue)}
                                    />
                                    {cashErr &&
                                        <div className="err-wrap-franch">
                                            <img src={iconError} alt="err-icon" />
                                            <span className="common-err franchisee-err">{cashErr}</span>
                                        </div>
                                    }
                                </li>

                            </ul>
                        </div>
                    }

                    <div className="upload-section">
                        <div className='upload-wrapper-franch'>
                            <div>
                                <label>Upload Approval Letter
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                {documentData["56"]?.isAvailable &&
                                    <>
                                        <span className="upload-text">Uploaded
                                            <img src={checkImge} alt="checkimage" />
                                        </span>

                                        <div className="check-image">
                                            <span className="file-wrap">
                                                <img
                                                    src={docImage}
                                                    alt="document-pic"
                                                />
                                                <label className="img-name"
                                                    title={documentData["56"]?.name || image?.name}>
                                                    {documentData["56"]?.name ||
                                                        image?.name}
                                                </label>
                                            </span>

                                            <div className="wrap-del-preview">
                                                <button
                                                    type="button"
                                                    onClick={() => deleteDoc("56")}
                                                    className="del-btn"
                                                >
                                                    <img
                                                        src={deleteImg}
                                                        alt="delete icon"
                                                    />
                                                    Delete
                                                </button>

                                                <div className="preview-text">
                                                    {(() => {
                                                        const fileName = documentData["56"]?.name || "";
                                                        const fileUrl = documentData["56"]?.url;
                                                        const fileExt = fileName.split(".").pop()?.toLowerCase();

                                                        const previewableTypes = ["txt"];
                                                        const isPreviewable = previewableTypes.includes(fileExt);

                                                        return isPreviewable ? (
                                                            // ✅ SHOW PREVIEW BUTTON
                                                            <span
                                                                className="icon-text"
                                                                role="button"
                                                                onClick={() => setImageModal(true)}
                                                            >
                                                                <img src={eyeIcon} alt="eye icon" />
                                                                Preview
                                                            </span>
                                                        ) : (
                                                            <a
                                                                href={fileUrl}
                                                                rel="noreferrer"
                                                                download
                                                            >
                                                                <img src={downloadbrokrage} alt="download icon" />
                                                                Download
                                                            </a>
                                                        );
                                                    })()}
                                                </div>

                                                {/* <div className="preview-text">
                                                    <span
                                                        className="icon-text"
                                                        type="button"
                                                        onClick={() =>
                                                            setImageModal(true)
                                                        }
                                                    >
                                                        <img
                                                            src={eyeIcon}
                                                            alt="eye icon"
                                                        />
                                                        Preview
                                                    </span>
                                                </div> */}
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>

                            <div className='upload-btn-wrap'>
                                <input
                                    type="file"
                                    id="approvalFile"
                                    name="approvalFile"
                                    // accept="image/png,image/jpeg,image/jpg, application/pdf"
                                    accept=".eml,.mbox,.vcf,.csv,.ics,.msg,.oft,.mht,.txt"
                                    className="file-input-hidden"
                                    onChange={(e) => handleImageUpload(e, 56)}
                                    key={image?.name || ""}
                                    disabled={documentData["56"]?.isAvailable}
                                />
                                {documentData["56"]?.isAvailable ?
                                    <label className="disable-btn-file">
                                        Choose File
                                    </label>
                                    :
                                    <label htmlFor="approvalFile" className="choose-file-btn">
                                        {docLoader ? (
                                            <SmallLoader />
                                        ) : (
                                            <>Choose File</>
                                        )}
                                    </label>
                                }

                            </div>
                        </div>
                        {docErr &&
                            <div className="err-wrap-franch">
                                <img src={iconError} alt="err-icon" />
                                <span className="common-err franchisee-err">{docErr}</span>
                            </div>
                        }

                        <div className="upload-instruction">
                            <span className="format-info">
                                Note: Please upload email-related files only (.eml, .mbox, .vcf, .csv, .ics, .msg, .oft, .mht, .txt). Max size: 2MB
                                {/* Note: Please upload document in .pdf, .jpg, .jpeg, .png format. Documents in .pdf, .jpg, .jpeg, .png format must have max size of 2MB */}
                            </span>
                        </div>


                    </div>

                    <div className="client-info-status ap-commercial-modal">
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                            <li className="disposition-select-back mtf-rate">
                                <div>
                                    <label htmlFor="" className="form-text">Remark
                                        <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <div className="input-arrow-wrapper remark-area">
                                        <input
                                            className="ap-sharing-input"
                                            type="text"
                                            value={remark}
                                            onChange={handleRemark}
                                            placeholder="Enter remaining value"
                                            maxLength={15}
                                            onInput={onlyNumber}
                                            onPaste={(e) => handleNumberPaste(e, 15, setRemark)}
                                        />
                                        {disposition !== "stock-cash" ?
                                            <label>To be adjusted from brokerage</label> :
                                            <label>Stock to be given</label>
                                        }
                                    </div>

                                    {remarkErr &&
                                        <div className="err-wrap-franch">
                                            <img src={iconError} alt="err-icon" />
                                            <span className="common-err franchisee-err">{remarkErr}</span>
                                        </div>
                                    }

                                </div>
                            </li>
                        </ul>
                    </div>

                    <button
                        type="submit"
                        className={`${!isFormValid ? "disable-btn-approve" : "approve-btn"}`}
                        disabled={!isFormValid}
                        onClick={() => handleApprovalBtn()}
                    >
                        APPROVE
                    </button>
                </Modal.Body>
            </Modal>

            <Modal
                show={showModal}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model partner-modal-rejection"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">Rejection Selection</h2>
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={onHide}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <ul className="partner-ul">
                        {rejectionData &&
                            rejectionData?.map((item) => {
                                return (
                                    <>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="resons"
                                                value={item?.id}
                                                className="downloadSelect"
                                                onClick={() => getReason()}

                                            />
                                            <label>{item?.reason}</label>
                                        </li>
                                    </>
                                );
                            })}
                        {/* </select> */}
                    </ul>
                    <button
                        type="submit"
                        className={selectedFiles.length ? "rej-btn " : "disabled-file"}
                        disabled={selectedFiles.length ? false : true}
                        onClick={() => rejectedUpdated()}
                    >
                        Submit
                    </button>
                </Modal.Body>
            </Modal>


            <Modal
                show={imageModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="ifscModal preview-modal"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setImageModal(false)}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <form className="modal-form select-new">
                        <div className="form-group">
                            {documentData["56"]?.isAvailable && (() => {
                                const fileUrl = documentData["56"]?.url;
                                const fileName = documentData["56"]?.name || "";
                                const fileExt = fileName.split(".").pop()?.toLowerCase();

                                if (!fileUrl) return null;

                                return (
                                    <>
                                        {fileExt === "txt" && (
                                            <iframe
                                                src={fileUrl}
                                                title="Text Preview"
                                                className="preview-iframe"
                                            />
                                        )}
                                    </>
                                );
                            })()}
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FrenchiseeDocumentDetailsPreview;
